import { Button } from "@caprikorn/dynamo-ui";
import type { FC } from "react";
import { Link } from "react-router-dom";

import { ErrorTemplate } from "@components/ErrorTemplate/ErrorTemplate";
import { Header } from "@components/Header/Header";
import { useMobileMenu } from "@contexts/MobileMenu/MobileMenu.context";
import { ROUTES } from "@router/router.constants";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./ErrorNotFound.module.css";

export const ErrorNotFound: FC = () => {
  const { t } = useCustomTranslation("common");
  const { openMobileMenu } = useMobileMenu();

  return (
    <>
      {openMobileMenu && <Header breadcrumbPaths={[]} />}
      <div className={classes.container}>
        <ErrorTemplate
          data-testid="ErrorNotFound-container"
          title={t("errors.notFound.title")}
        />

        <Button as={Link} to={ROUTES.DASHBOARD}>
          {t("errors.notFound.button")}
        </Button>
      </div>
    </>
  );
};
